import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {
  PublishableVersionAction,
  PUBLISHABLE_VERSION_ACTION_TO_ICON,
} from 'notebook/template-publishing/TemplatePublishingConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

const PUBLISHABLE_VERSION_ACTION_TO_DESCRIPTION: Record<PublishableVersionAction, string> = {
  [PublishableVersionAction.CREATE_DRAFT]: 'Create new draft',
  [PublishableVersionAction.PUBLISH]: 'Publish version',
  [PublishableVersionAction.WITHDRAW]: 'Withdraw version',
};

export interface TemplatePublishingButtonOptionProps {
  publishableVersionAction: PublishableVersionAction;
  isDisabled?: boolean;
}

function TemplatePublishingButtonOption({
  publishableVersionAction,
  isDisabled,
}: TemplatePublishingButtonOptionProps): JSX.Element {
  return (
    <div
      className={classNames(
        'template-publishing-dropdown-option',
        css(styles.templatePublishingDropdownOption, isDisabled && styles.dropdownOptionDisabled)
      )}
    >
      <span className={css(!isDisabled && styles.icon)}>
        <BenchlingIcon icon={PUBLISHABLE_VERSION_ACTION_TO_ICON[publishableVersionAction]} />
      </span>
      <span>{PUBLISHABLE_VERSION_ACTION_TO_DESCRIPTION[publishableVersionAction]}</span>
    </div>
  );
}

const styles = StyleSheet.create({
  templatePublishingDropdownOption: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.6em',
    color: Color.GRAY_900,
  },
  dropdownOptionDisabled: {
    color: Color.GRAY_500,
  },
  icon: {
    color: Color.GRAY_600,
  },
});

export default TemplatePublishingButtonOption;
